import {
  Chip,
  DataArray,
  UpdateIconButton,
  formatBoolean,
  pn,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@compass/core";

import { ListBeProperty } from "components";
import {
  Permission,
  PermissionAction,
  SortObject,
  StaffServiceTypeListDto,
  StaffServiceTypeListResource,
  StaffServiceTypeListFilter,  
} from "generated/openApi";
import { useNavigate } from "react-router-dom";
import { isAuthorized } from "services";
import { staffServiceTypePageRoute } from "../StaffServiceTypePage/StaffServiceTypePage";

export const StaffServiceTypeTable = (props: {
  rootPermission: Permission;
  tableContainerRef: React.RefObject<HTMLDivElement>;
  staffServiceTypes: StaffServiceTypeListDto[];
  setStaffServiceTypes: (staffServiceTypes: StaffServiceTypeListDto[]) => void;
  resource: StaffServiceTypeListResource;
  searchFocused: boolean;
  sortObjects: SortObject[] | undefined;
  sort: (sortObjects: SortObject[]) => void;
  loadList: () => void;
  listFilter: StaffServiceTypeListFilter;
}) => {
  const navigate = useNavigate();
  const properties = props.resource.properties || [];

  return (
    <TableContainer ref={props.tableContainerRef}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell style={{ width: "7%"}}>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<StaffServiceTypeListDto>("id"))}
                searchFocused={props.searchFocused}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
              />
            </TableCell>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<StaffServiceTypeListDto>("name"))}
                searchFocused={props.searchFocused}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
              />
            </TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {props.staffServiceTypes.map((staffServiceTypeItem) => (
            <TableRow
              key={staffServiceTypeItem.id}
              onClick={() =>
                navigate(
                  staffServiceTypePageRoute.getPath({
                    id: staffServiceTypeItem.id,
                    crudMode: "view",
                    screenType: "dialog"
                  })
                )
              }
            >
              <TableCell>{staffServiceTypeItem.id}</TableCell>
              <TableCell>
                <Stack direction="row" spacing="sm" alignItems="center" justifyContent={"space-between"}>
                  <Typography variant="inherit">{staffServiceTypeItem.name}</Typography>
                </Stack>
              </TableCell>
              <TableCell type="action">
                {isAuthorized(props.rootPermission, PermissionAction.Update) && (
                  <UpdateIconButton color="primary"
                    onClick={() =>
                      navigate(
                        staffServiceTypePageRoute.getPath({
                          id: staffServiceTypeItem.id,
                          crudMode: "edit",
                          screenType: "dialog"
                        })
                      )
                    }
                  />
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
